import { FC, useEffect } from 'react';
import classNames from 'classnames';
import { FiltersOptionGroup } from './Filters.types';
import { useFilters } from './Filters.helpers';
import { FiltersOptionsGroup } from './FiltersOptionsGroup';
import { FiltersSearchInput } from './FiltersSearchInput';
import { Sticky } from '../Sticky/Sticky';

import './filters.scss';

export interface FiltersProps {
  className?: string;
  optionGroups: FiltersOptionGroup[];
}

export const Filters: FC<FiltersProps> = ({ className, optionGroups }) => {
  const { actions } = useFilters();
  const { clearFilters } = actions;

  // Clear filters on unmount
  useEffect(() => () => clearFilters(), []);

  return (
    <Sticky>
      <div className={classNames('filters bg-brand-text-50 pt-2 pb-2 mb-2', className)}>
        <FiltersSearchInput />

        {optionGroups.map(({ name, ...optionGroup }) => (
          <FiltersOptionsGroup key={name} name={name} {...optionGroup} />
        ))}
      </div>
    </Sticky>
  );
};
